import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from "@angular/material/tabs";

import {
  ButtonComponentModule,
  LanternCommonModule
} from "@lantern/app/common";
import {
  FormFieldComponentModule,
  InputComponentModule
} from "@lantern/app/common/forms";

import { ComponentZooComponent } from "./component-zoo.component";

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LanternCommonModule,
    FormFieldComponentModule,
    InputComponentModule,
    ButtonComponentModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatTabsModule
  ],
  declarations: [ComponentZooComponent],
  exports: [ComponentZooComponent]
})
export class ComponentZooModule {}
